export const voloteaConfiguration = {
  volotea_configurations: `Configuraciones de Volotea`,
};
